import { UseQueryOptions } from '@tanstack/react-query';

import { equipmentBrowserGetEquipmentBrowserView } from '@repo/sdk/funcs/equipmentBrowserGetEquipmentBrowserView';
import { EquipmentBrowserViewResponse } from '@repo/sdk/models/components';
import { SDKError } from '@repo/sdk/models/errors';
import { GetEquipmentBrowserViewRequest } from '@repo/sdk/models/operations';

import { GaiaClientFunction } from '@/client/types';
import { GaiaQueryWithAgentId } from '@/queries/types';

interface GetEquipmentBrowserViewQueryProps extends GaiaQueryWithAgentId {
  client: GaiaClientFunction;
  viewId?: string;
}

export const getEquipmentBrowserViewQuery = ({
  agentId,
  viewId,
  client,
}: GetEquipmentBrowserViewQueryProps): UseQueryOptions<
  EquipmentBrowserViewResponse,
  SDKError,
  EquipmentBrowserViewResponse | undefined
> => {
  return {
    // While viewId is optional, we only want to fetch it if it is provided to prevent multiple queries for the same agentId
    enabled: !!agentId && !!viewId,
    queryKey: [agentId, 'getEquipmentBrowserView', viewId],
    queryFn: () =>
      client<GetEquipmentBrowserViewRequest, EquipmentBrowserViewResponse>({
        gaiaFunc: equipmentBrowserGetEquipmentBrowserView,
        request: {
          agentId: agentId!,
          viewId: viewId,
        },
      }),
    staleTime: Infinity,
  };
};
